import type { FC } from 'react';

import { withPropsFromUrl } from './utils';
import { FilterSelect } from '../../components';
import { LeagueStageEnum } from '../../shared/league-status-enum';
import type { SharedFilterProps, WithPropsFromUrl } from './types';
import { startCase } from '../../shared/string-manipulations';

const programStatusOptions = Object.values(LeagueStageEnum).map(value => ({
  label: startCase(value),
  value,
}));

const ProgramStatusFilter: FC<WithPropsFromUrl & SharedFilterProps> = props => {
  const { programStatus, disabled, onSelect, isMulti, className, updateSearchUrls } = props;

  const onChange =
    typeof onSelect === 'function'
      ? onSelect
      : (ps: { label: string; value: string }) =>
          updateSearchUrls({ programStatus: (ps?.value as LeagueStageEnum) || 'CLEAR' });

  return (
    <FilterSelect
      short
      shadow
      labelSingular="Program Status"
      labelPlural="Program Status"
      options={programStatusOptions}
      value={programStatusOptions.filter(({ value }) => [programStatus].includes(value)) || null}
      onChange={onChange}
      disabled={disabled}
      multi={isMulti}
      clearable
      className={className}
    />
  );
};

export default withPropsFromUrl()(ProgramStatusFilter);
